import React from "react";
import { Shimmer } from "..";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type SkeletonPostProps = {
  _profileImage?: string;
  UserName?: string;
  post: string;
};
const SkeletonPost: React.FC<SkeletonPostProps> = ({
  _profileImage,
  UserName,
  post,
}) => {
  return (
    <div className="mb-3 w-full mx-auto items-center bg-[#f2f2f2] shadow-sm py-3 px-4 lg:mb-0 rounded flex flex-col overflow-hidden relative">
      <div className="flex w-full mx-auto justify-between items-center">
        <div className="flex w-[70%] gap-2">
          <div className="relative w-5 h-5 rounded-full">
            <img
              src={ipfsGatewayImage(_profileImage!)}
              alt=""
              className="w-5 h-5 rounded-full"
            />
            <div className="absolute bg-[rgba(0,0,0,0.4)] w-5 h-5 rounded-full top-0"></div>
          </div>

          <div className="flex h-5 flex-col w-[70%] text-[rgba(0,0,0,0.4)] font-medium text-[6px]">
            <div className="flex">{UserName}</div>
            <div className="flex">{"public"}</div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap w-[98%] font-medium  mt-1 text-[6px] text-[rgba(0,0,0,0.4)] font-Poppins">
        {post}
      </div>
      {/* <SkeletonElement type="text" />
      <SkeletonElement type="text" />
      <SkeletonElement type="text" />
      <SkeletonElement type="text" />
      <div className="mt-6 border-t pt-2 w-full flex justify-between">
        <div className="flex w-[15%] justify-between">
          <SkeletonElement type="icon2" />
          <SkeletonElement type="icon2" />
          <SkeletonElement type="icon2" />
        </div>

        <div className=" float-right">
          <SkeletonElement type="icon2" />
        </div>
      </div> */}
      <Shimmer />
    </div>
  );
};

export default SkeletonPost;
